import { IAppState } from '../../store';

export const selectLocation = (state: IAppState) => state.personalLeadsForm.data.location;
